import { SOGetEntityPermission } from '../entity-permission/so-get-entity-permission';
import { SOGetRelationshipAttributePermission } from '../relationship-attribute-permission/so-get-relationship-attribute-permission';
import { SOGetSimpleAttributePermission } from '../simple-attribute-permission/so-get-simple-attribute-permission';
import { SOGetRole } from '../role/so-get-role';
import { SOGetProject } from '../project/so-get-project';
import { SOGetOrganization } from '../organization/so-get-organization';
import {MMQueryOptions} from 'lionheartland';
import {QueryProtocol} from 'lionheartland';


export class SOGetRolePermission implements QueryProtocol {

  constructor(
    public uid: string = null,
    public name: string = null,
    public entityPermission: SOGetEntityPermission = null,
    public relationshipAttributePermission: SOGetRelationshipAttributePermission = null,
    public simpleAttributePermission: SOGetSimpleAttributePermission = null,
    public role: SOGetRole = null,
    public project: SOGetProject = null,
    public organization: SOGetOrganization = null,
    public predicate: string = null,
    public queryOptions: MMQueryOptions = new MMQueryOptions(),
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOGetRolePermission(
      'uid' in params ? params.uid : null,
      'name' in params ? params.name : null,
      'entityPermission' in params ? params.entityPermission : null,
      'relationshipAttributePermission' in params ? params.relationshipAttributePermission : null,
      'simpleAttributePermission' in params ? params.simpleAttributePermission : null,
      'role' in params ? params.role : null,
      'project' in params ? params.project : null,
      'organization' in params ? params.organization : null,
      'predicate' in params ? params.predicate : null,
      'queryOptions' in params ? params.queryOptions : new MMQueryOptions(),
    );
  }
}
